
<template>
    <form action="/billing/update-card" method="POST" id="payment-form" @submit.prevent="pay()">

      <div class="form-group">
          <label for="email">Billing Email (billing notifications will be sent to this address)</label>
          <input type="email" class="form-control" id="email" name="email">
      </div>


      <div class="form-group">
          <label for="name_on_card">Name on Card</label>
          <input type="text" class="form-control" id="name_on_card" name="name_on_card" required v-model="name_on_card">
      </div>

      <div class="form-group">
          <label for="card-element">Credit Card</label>

          <div id="card-element"></div>

          
      </div>



      <!-- CSRF Field -->
      <input type="hidden" name="_token" :value="csrf">

      <div class="spacer"></div>

      <div class="form-row">
          <div class="form-group col order-2 mb-0">
              <a class="btn btn-secondary" href="/billing"><i class="fa fa-btn fa-undo"></i> Back</a>
          </div>
          <div class="form-group col order-2 mb-0 text-right">
               <button class="btn btn-primary" id="card-button" :data-secret="secret">Update Payment Method</button>    
          </div>
      </div>


  </form>
</template>

<script>

import Noty from 'noty';
    
    export default {
        props: [
            'pk',
            'secret',
        ],
        mounted(){
              this.stripe = Stripe(this.pk);

              const elements = this.stripe.elements();
              this.cardelement = elements.create('card',{                
                style: {
                  base: {
                    color: '#32325d',
                    
                    fontFamily: '"Nunito", sans-serif',
                    fontSize: '14.4px',
                    '::placeholder': {
                      color: '#aab7c4'
                    }
                  },
                  invalid: {
                    color: '#fa755a',
                    iconColor: '#fa755a'
                  }
                },
                hidePostalCode: false
              });

              this.cardelement.mount('#card-element');


        },
        data () {
            return {
              stripe:'',
              cardelement:'',
              csrf: document.head.querySelector('meta[name="csrf-token"]').content,
              name_on_card: '',
            }
        },
        methods: {
            pay: async function () {

              const cardHolderName = document.getElementById('name_on_card');
              const cardButton = document.getElementById('card-button');
              const clientSecret = cardButton.dataset.secret;
              var vm = this;
              const { setupIntent, error } = await vm.stripe.confirmCardSetup(
                  clientSecret, {
                      payment_method: {
                          card: vm.cardelement,
                          billing_details: { name: vm.name_on_card }
                      }
                  }
              );

              if (error) {
                  // Display "error.message" to the user...

                  	var message = error.message;

	                new Noty({
	                    text: 'Error: ' + message,
	                    type: 'error',
	                    theme: 'bootstrap-v4',
	                    layout: 'topCenter',
	                    timeout: false
	                }).show();

                  //console.log(error);


              } else {
                  var hiddenInput = document.createElement('input');
                  hiddenInput.setAttribute('type', 'hidden');
                  hiddenInput.setAttribute('name', 'stripePaymentMethodToken');
                  hiddenInput.setAttribute('value', setupIntent.payment_method);
                  this.$el.appendChild(hiddenInput);
                  // Submit the form
                  this.$el.submit();
              }

        

           
            }
      }
    }
</script>